export default "__VITE_ASSET__BJ6MMFI8__"